import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ListChecks, X } from "lucide-react";
import { Card } from "@/components/ranger/PageHeader";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export const OnboardingGuide = ({ cid }) => {
  const { can } = useAuth();
  const key = `ranger.onboarding.hidden.${cid}`;
  const [d, setD] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(key) === "1");
  useEffect(() => { if (can("admin")) { api.get(`/communities/${cid}/onboarding`).then((r) => setD(r.data)).catch(() => {}); } }, [cid, can]);
  if (!d || hidden || d.done === d.total) return null;
  const hide = () => { localStorage.setItem(key, "1"); setHidden(true); };
  return (
    <Card title={`Getting started · ${d.done}/${d.total}`} icon={ListChecks} testId="onboarding-card" className="mb-6"
      right={<button data-testid="onboarding-hide" onClick={hide} aria-label="Hide checklist" className="text-slate-500 hover:text-slate-200"><X className="h-4 w-4" /></button>}>
      <div className="mb-4 h-1 w-full rounded-full bg-[#1E2D4A]"><div className="h-1 rounded-full bg-[#E5202E] transition-[width] duration-500" style={{ width: `${(d.done / d.total) * 100}%` }} /></div>
      <ul className="grid gap-2 sm:grid-cols-2">{d.items.map((i) => (
        <li key={i.key} data-testid={`onboarding-item-${i.key}`}>
          <Link to={i.to} className="flex items-center gap-3 rounded-sm px-2 py-1.5 text-sm transition-colors hover:bg-[#111A2E]">
            {i.done ? <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-400" /> : <Circle className="h-4 w-4 shrink-0 text-slate-600" />}
            <span className={i.done ? "text-slate-500 line-through" : "text-slate-200"}>{i.label}</span>
          </Link>
        </li>))}</ul>
    </Card>
  );
};
